<template>
	<div class="comp">
		<el-dialog :title="'活动信息'" :visible.sync="dialogState" width="1300px" top="100px">
			<el-row style="padding:20px 0 10px;font-size: 18px;line-height: 30px;">
				<el-col :span="6" :offset="1">活动名称：{{detail.name}}</el-col>
				<el-col :span="6">截止日期：{{$public.FTime(detail.exprice_time)}}</el-col>
				<el-col :span="10">备注：{{detail.remark}}</el-col>
			</el-row>
			<div class="tabLine">
				<div class="tabItem" :class="[curTabIndex==0?'active':'']" @click="changeTab(0)">服务</div>
				<div class="tabItem" :class="[curTabIndex==1?'active':'']" @click="changeTab(1)">商品</div>
			</div>
			<div style="padding-bottom:40px" v-if="curTabIndex==0&&detail.consume_item!=undefined">
				<!-- 0：全部 1：品牌 2：类型 3：指定商品 -->
				<div style="padding:20px 0 0;display: flex;"  v-if="detail.consume_item.servers_consume_item.type==0">
					<span style="font-size: 16px;width:120px;">优惠服务：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;">
							全部服务
						</span>
					</span>
				</div>
				<div style="padding:20px 0 0;display: flex;"  v-if="detail.consume_item.servers_consume_item.type==1">
					<span style="font-size: 16px;width:120px;">优惠品牌：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;" v-for="(item,index) in detail.consume_item.servers_consume_item.param" :key="index">
							{{index+1}}、{{item.name}}
						</span>
					</span>
				</div>
				<div style="padding:20px 0 0;display: flex;"  v-if="detail.consume_item.servers_consume_item.type==2">
					<span style="font-size: 16px;width:120px;">优惠类型：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;" v-for="(item,index) in detail.consume_item.servers_consume_item.param" :key="index">
							{{index+1}}、{{item.name}}
						</span>
					</span>
				</div>
				<div style="padding:20px 0 0;display: flex;" v-if="detail.consume_item.servers_consume_item.type==3">
					<span style="font-size: 16px;width:120px;">优惠指定服务：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;" v-for="(item,index) in detail.consume_item.servers_consume_item.param" :key="index">
							{{index+1}}、{{item.name}}
						</span>
					</span>
				</div>
				<!-- <div style="display: flex;margin-top:40px;" v-if="detail.give_services">
					<div style="line-height: 50px;padding-right: 20px;">赠送服务:</div>
					<el-table v-if="detail.consume_item" :data="detail.give_services">
						<el-table-column prop="service_name" label="服务名称">
						</el-table-column>
						<el-table-column prop="price" label="规格" width="400">
						</el-table-column>
						<el-table-column prop="days" label="天数" width="300">
						</el-table-column>
					</el-table>
				</div> -->
			</div>
			<div style="padding-bottom:40px" v-if="curTabIndex==1&&detail.consume_item">
				<!-- 0：全部 1：品牌 2：类型 3：指定商品 -->
				<div style="padding:20px 0 0;display: flex;" v-if="detail.consume_item.goods_consume_item.type==0">
					<span style="font-size: 16px;width:120px;">优惠商品：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;">
							全部商品
						</span>
					</span>
				</div>
				<div style="padding:20px 0 0;display: flex;" v-if="detail.consume_item.goods_consume_item.type==1">
					<span style="font-size: 16px;width:120px;">优惠品牌：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;" v-for="(item,index) in detail.consume_item.goods_consume_item.param" :key="index">
							{{index+1}}、{{item.name}}
						</span>
					</span>
				</div>
				<div style="padding:20px 0 0;display: flex;" v-if="detail.consume_item.goods_consume_item.type==2">
					<span style="font-size: 16px;width:120px;">优惠类型：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;" v-for="(item,index) in detail.consume_item.goods_consume_item.param" :key="index">
							{{index+1}}、{{item.name}}
						</span>
					</span>
				</div>
				<div style="padding:20px 0 0;display: flex;" v-if="detail.consume_item.goods_consume_item.type==3">
					<span style="font-size: 16px;width:120px;">优惠指定商品：</span>
					<span style="width:1100px;display: flex;flex-wrap: wrap;">
						<span style="margin:0px 30px 15px 0;" v-for="(item,index) in detail.consume_item.goods_consume_item.param" :key="index">
							{{index+1}}、{{item.name}}
						</span>
					</span>
				</div>
				<!-- <div style="display: flex;margin-top:40px;" v-if="detail.give_goods">
					<div style="line-height: 50px;padding-right: 20px;">赠送商品:</div>
					<el-table v-if="detail.consume_item" :data="detail.give_goods">
						<el-table-column prop="goods_name" label="商品名称">
						</el-table-column>
						<el-table-column prop="price" label="规格" width="400">
						</el-table-column>
						<el-table-column prop="goods_count" label="数量" width="300">
						</el-table-column>
					</el-table>
				</div> -->
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				title:'',
				curTabIndex:0, 
				detail:{},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		props:{
			row:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(n){
				this.$emit('close',n)
			}
		},
		mounted() {
			this.detail = this.row
			console.log(this.detail)
		},
		methods: {
			// 改变tab
			changeTab(index){
				this.curTabIndex=index;
			},
			
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.navLine{
			display: flex;
			font-size: 18px;
			border-bottom:1px solid #DDDDDD;
			.label{
				color:#1A1A1A;
				font-weight: bold;
				padding:10px 10px 10px 27px;
			}
			.navItem{
				color:#555555;
				margin:0 20px;
				padding:10px 0;
				cursor: pointer;
				&.active{
					border-bottom:2px solid #FDD000;
				}
			}
		}
		.tabLine{
			display: flex;
			margin:20px 0 10px;
			.tabItem{
				margin-right: 40px;
				padding:0 10px 5px;
				font-size: 16px;
				cursor: pointer;
				&.active{
					color:#FDD000;
					border-bottom:2px solid #FDD000;
				}
			}
		}
		::v-deep.el-dialog__body{
			padding-top:0;
		}
	}
</style>
